<template>
  <section class="custom-scale-host">
    <div class="row">
      <div class="col-3"></div>
      <div class="col"></div>
      <div class="col-3 custom-right">
        <!-- <button class="btn btn-link" @click="getInstructions">
          instructions
        </button> -->
      </div>
    </div>
    <div class="row">
      <div class="col-3"></div>
      <div class="col text-center">
        <div class="custom-actions">
          <!-- <button class="btn btn-primary" @click="pairDevice">Pair</button> -->
          <!-- <button
            v-show="isPaired"
            :disabled="isContinue"
            class="btn btn-primary ms-2"
            @click="startTest"
          >
            Start
          </button>
          <button
            v-show="isPaired"
            :disabled="!isContinue"
            class="btn btn-primary ms-2"
            @click="stopTest"
          >
            Finish
          </button>
          <button
            v-show="isPaired"
            :disabled="!isContinue"
            class="btn btn-primary ms-2"
            @click="cancelTest"
          >
            Cancel
          </button> -->
        </div>
      </div>
      <div class="col-3"></div>
    </div>
    <div class="row">
      <div class="col-3"></div>
      <div class="col custom-scale-wrapper">
        <div class="custom-scale">
          <!-- <i
            v-if="isStarted"
            class="fas fa-weight fa-pulse custom-pulse-icon"
          ></i> -->
          <span v-if="isStarted || isCalculated"
            >{{ formatNumber(measurement.bodyweight) }} lbs</span
          >
        </div>
        <div v-if="isStarted || isCalculated" class="custom-scale">
          <span>{{ formatNumber(measurement.bodyfat) }} %</span
          ><span class="custom-bodyfat">(body fat)</span>
        </div>
      </div>
      <div class="col-3"></div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-2">
        <!-- <div v-show="isCalculated" class="custom-save">
          <button class="btn btn-primary" :disabled="isSaving" @click="save">
            Save
          </button>
        </div> -->
      </div>
      <div class="col"></div>
    </div>
    <instructions-dialog :show="actionInstructions" @close="closeModal" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZInput from '@/Components/ZElements/Input'
import InstructionsDialog from './instructions-dialog'
export default {
  name: 'scale',
  components: {
    ZInput,
    InstructionsDialog,
  },
  data() {
    return {
      channel: null,
      isStarted: false,
      measurement: {
        userId: null,
        entrydate: null,
        age: null,
        height: 0,
        bodyweight: 0,
        bodyfat: 0,
        vFat: 0,
        bmi: 0,
        bmr: 0,
        boneKg: null,
        muscleKg: null,
        waterPct: null,
        bodyType: null,
        isFromScale: 1,
      },
      pulse: null,
      isPaired: false,
      actionInstructions: null,
      isCalculated: false,
      dontCalculate: false,
      isContinue: false,
      isSaving: false,
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('bodycomposition', ['bodycomposition']),
    ...mapGetters('usercardio', ['member', 'summary']),
    id() {
      let _id = ''
      if (this.member) {
        _id = this.member.id
      }
      return _id
    },
    entrydate() {
      let _data = ''
      if (this.summary) {
        if (this.summary.week) {
          _data = moment().format('YYYY-MM-DD')
          this.measurement.entrydate = _data
        }
      }
      return _data
    },
  },
  methods: {
    ...mapActions('bodycomposition', ['createFullMeasurement']),
    init() {
      this.isStarted = false
      this.isCalculated = false
      this.isSaving = false
      this.channel = Echo.join('direct').listenForWhisper('scale', (e) => {
        this.pulse = e
        if (parseInt(this.pulse.userId) === parseInt(this.member.id)) {
          if (this.pulse.action === 'start') {
            this.isStarted = true
            this.isCalculated = false
            this.measurement = {
              userId: this.member.id,
              entrydate: null,
              age: parseInt(this.member.age),
              height: parseInt(this.member.height),
              bodyweight: parseFloat(this.pulse.data.weight),
              bodyfat: parseFloat(this.pulse.data.percentBodyFat),
              vFat: parseFloat(this.pulse.data.vFat),
              bmi: parseFloat(this.pulse.data.bmi),
              bmr: parseFloat(this.pulse.data.bmr),
              boneKg: null,
              muscleKg: parseFloat(this.pulse.data.percentMuscle),
              waterPct: null,
              bodyType: null,
              isFromScale: 1,
            }
            this.$emit('showSave', true)
          } else if (this.pulse.action === 'stop2') {
            this.isStarted = false
            this.dontCalculate = false
            this.isCalculated = false
            this.isContinue = false
            this.$emit('showSave', false)
            this.$emit('close')
          } else if (this.pulse.action === 'stop') {
            this.isStarted = false
            this.$emit('showSave', false)
            if (!this.dontCalculate) {
              this.calculateResults()
            }
          }
        }
      })
    },
    closeModal() {
      this.actionInstructions = null
    },
    formatNumber(number) {
      let value = null
      if (number) {
        value = parseFloat(number).toFixed(1)
      }
      return value
    },
    pairDevice() {
      this.cancelTest()
      this.isPaired = true
      let command = `nuvita://assessment/run/scale?host=${
        window.socketUrl
      }&app_cluster=mt1&app_key=app-key&coach_user_id=${
        this.profile.id
      }&user_id=${this.member.id}&height=${this.member.height}&weight=${
        this.member.weight
      }&age=${this.member.age}&gender=${this.member.gender
        .toUpperCase()
        .charAt(0)}`
      console.log('Pair Device', command)
      try {
        // window.location.replace(command)
        window.open(command, '_blank')
      } catch (e) {}
    },
    startTest() {
      this.isContinue = true
      this.dontCalculate = false
      console.log('Starting Test', this.member)
      this.channel.whisper('scaleaction', {
        userId: this.member.id,
        data: {
          height: parseFloat(this.member.height),
          weight: parseFloat(this.member.weight),
          age: parseInt(this.member.age),
          gender: this.member.gender,
        },
        action: 'start',
        protocol: this.protocol,
      })
    },
    stopTest() {
      this.isContinue = false
      this.channel.whisper('scaleaction', {
        userId: this.member.id,
        data: null,
        action: 'stop',
        protocol: this.protocol,
      })
    },
    cancelTest() {
      let $this = this
      this.dontCalculate = true
      this.isContinue = false
      this.channel.whisper('scaleaction', {
        userId: this.member.id,
        data: null,
        action: 'stop',
        protocol: this.protocol,
      })
      setTimeout(() => {
        $this.dontCalculate = false
        $this.isCalculated = false
      }, 300)
    },
    calculateResults() {
      this.isCalculated = true
    },
    getInstructions() {
      this.actionInstructions = {
        instructions: 'Instructions will go here.',
      }
    },
    async save() {
      // Save Here
      this.isSaving = true
      console.log('Save Body Comp Measurement', this.measurement)
      let results = await this.createFullMeasurement(this.measurement)
      this.stopTest()
      this.isCalculated = false
      this.isSaving = false
      this.$emit('saved')
    },
  },
  // beforeUnmount() {
  //   Echo.leave('direct')
  // },
}
</script>
<style lang="scss" scoped>
.custom-scale-host {
  min-height: 300px;
}
.custom-right {
  text-align: right;
}
.custom-actions {
  position: relative;
  left: 15px;
  top: 7px;
}
.custom-scale-wrapper {
  text-align: center;
  padding-top: 20px;
}
.custom-pulse-icon {
  color: rgb(201, 0, 0);
}
.custom-scale {
  width: 200px;
  position: relative;
  margin: 0 auto;
  span {
    font-size: 1.8em;
    font-weight: 500;
    margin-left: 10px;
  }
  i {
    font-size: 1.2em;
  }
}
.custom-bodyfat {
  font-size: 0.9em !important;
}
.custom-save {
  position: relative;
  text-align: center;
  margin-top: 10px;
}
/* Icon pulse */
.fa-pulse {
  display: inline-block;
  -moz-animation: pulse 3s infinite linear;
  -o-animation: pulse 3s infinite linear;
  -webkit-animation: pulse 3s infinite linear;
  animation: pulse 3s infinite linear;
}

@-webkit-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-ms-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
